import { render, staticRenderFns } from "./alice.vue?vue&type=template&id=4e9e64f4&scoped=true"
import script from "./alice.vue?vue&type=script&lang=js"
export * from "./alice.vue?vue&type=script&lang=js"
import style0 from "./alice.vue?vue&type=style&index=0&id=4e9e64f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e64f4",
  null
  
)

export default component.exports